var React = require('react');

function Initiate (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3 12.75 9 9 9-9h-4.5v-6h-9v6H3ZM16.5 3.75h-9","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Initiate.defaultProps = {"viewBox":"0 0 24 24","fill":"none","strokeWidth":"2.002"};

module.exports = Initiate;

Initiate.default = Initiate;
